import { serviceIds } from "../const/const";
import { ServiceId, AppSvcStatus, AccountLvlStatus } from "../types/types";

export const isServiceId = (v: unknown): v is ServiceId =>
  typeof v === "string" && (serviceIds as readonly string[]).includes(v);

export const appSvcStatusToValue = (s?: AppSvcStatus | null) => s === "on";
export const accLvlStatusToValue = (s?: AccountLvlStatus | null) =>
  s === "checked";
export const appSvcIsLocked = (s?: AppSvcStatus | null) => s === "locked";
export const appSvcIsDisabled = (s?: AppSvcStatus | null) => s === "disabled";
export const isLocked = (s?: AppSvcStatus | AccountLvlStatus | null) =>
  s === "locked";
export const isDisabled = (s?: AccountLvlStatus | null) => s === "disabled";
export const boolToAppStatus = (v: boolean): "on" | "off" => (v ? "on" : "off");

export const getErrMsg = (e: unknown): string => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const any = e as any;

  return (
    any?.data?.message ||
    any?.data?.error ||
    any?.error ||
    any?.message ||
    "Произошла ошибка"
  );
};
